<form
  [formGroup]="form"
  [patchForm]="operationInternalEvent"
  (ngSubmit)="onFormSubmit()"
  [canEdit]="[accessRights.OperationInternalEvents_write]"
>
  <div class="row">
    <div class="col-lg-6">
      <div class="mb-4">
        <label class="form-label">
          {{ 'general.event' | translate }}
          <small>({{ 'general.isRequired' | translate }})</small>
          <i
            class="ms-2 fa fa-question-circle"
            role="button"
            tabindex="0"
            [tooltip]="'operationInternalEventModule.typeTooltip' | translate"
          ></i>
        </label>

        <select
          formControlName="internalEventId"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.internalEventId.dirty &&
            form.controls.internalEventId.invalid
              ? 'true'
              : null
          "
          required
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option
            *ngFor="let internalEvent of internalEvents$ | async"
            [ngValue]="internalEvent.id"
          >
            {{ InternalEventTypes[internalEvent.type] }}
          </option>
        </select>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.internalEventId.dirty &&
            form.controls.internalEventId.invalid
          "
        >
          {{ 'general.internalEventId' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'surveyModule.survey' | translate }}
        </label>

        <select
          formControlName="surveyId"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.surveyId.dirty && form.controls.surveyId.invalid
              ? 'true'
              : null
          "
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option *ngFor="let survey of surveys$ | async" [ngValue]="survey.id">
            {{ survey?.name }}
          </option>
        </select>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.surveyId.dirty && form.controls.surveyId.invalid"
        >
          {{ 'surveyModule.survey' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div
        class="mb-4"
        [hidden]="
          [InternalEventTypes.SALE_SUCCESS].includes(
            (internalEvents$ | async)[form.controls.internalEventId.value]?.type
          )
        "
      >
        <label class="form-label">
          {{ 'productModule.product' | translate }}
        </label>
        <ng-select
          [items]="products$ | async"
          bindLabel="description"
          bindValue="id"
          formControlName="productId"
          (search)="onSearch($event)"
        ></ng-select>
        <!-- <select
          formControlName="productId"
          class="form-select"
          [attr.aria-invalid]="form.controls.productId.dirty && form.controls.productId.invalid ? 'true' : null"        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option
            *ngFor="let product of products$ | async"
            [ngValue]="product.id"
          >
            {{ product.description }}
          </option>
        </select> -->

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.productId.dirty && form.controls.productId.invalid
          "
        >
          {{ 'productModule.product' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div
        class="mb-4"
        [hidden]="
          [InternalEventTypes.SALE_SUCCESS].includes(
            (internalEvents$ | async)[form.controls.internalEventId.value]?.type
          )
        "
      >
        <label class="form-label">
          {{ 'courseModule.course' | translate }}
        </label>

        <select
          formControlName="courseId"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.courseId.dirty && form.controls.courseId.invalid
              ? 'true'
              : null
          "
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option *ngFor="let course of courses$ | async" [ngValue]="course.id">
            {{ course.description }}
          </option>
        </select>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.courseId.dirty && form.controls.courseId.invalid"
        >
          {{ 'courseModule.course' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div
        class="mb-4"
        [hidden]="
          [InternalEventTypes.SALE_SUCCESS].includes(
            (internalEvents$ | async)[form.controls.internalEventId.value]?.type
          )
        "
      >
        <label class="form-label">
          {{ 'subscriptionModule.subscription' | translate }}
        </label>

        <select
          formControlName="subscriptionId"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.subscriptionId.dirty &&
            form.controls.subscriptionId.invalid
              ? 'true'
              : null
          "
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option
            *ngFor="let subscription of subscriptions$ | async"
            [ngValue]="subscription.id"
          >
            {{ subscription.description }}
          </option>
        </select>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.subscriptionId.dirty &&
            form.controls.subscriptionId.invalid
          "
        >
          {{ 'subscriptionModule.subscription' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div
        class="mb-4"
        [hidden]="
          [InternalEventTypes.OPEN_ID_CREATED].includes(
            (internalEvents$ | async)[form.controls.internalEventId.value]?.type
          )
        "
      >
        <label class="form-label">
          {{ 'operationModule.operationType' | translate }}
          <i
            class="ms-2 fa fa-question-circle"
            role="button"
            tabindex="0"
            [tooltip]="
              'operationInternalEventModule.operationTypeToolTip' | translate
            "
          ></i>
        </label>

        <select
          formControlName="operationType"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.operationType.dirty &&
            form.controls.operationType.invalid
              ? 'true'
              : null
          "
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option
            *ngFor="let operationTypeKeyVal of OperationTypes"
            [ngValue]="operationTypeKeyVal.value"
          >
            {{ operationTypeKeyVal.value }}
          </option>
        </select>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.operationType.dirty &&
            form.controls.operationType.invalid
          "
        >
          {{ 'operationModule.operationType' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'general.role' | translate }}
          <i
            class="ms-2 fa fa-question-circle"
            role="button"
            tabindex="0"
            [tooltip]="'operationInternalEventModule.roleIdToolTip' | translate"
          ></i>
        </label>

        <select
          formControlName="roleId"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.roleId.dirty && form.controls.roleId.invalid
              ? 'true'
              : null
          "
        >
          <option [ngValue]="null" selected>
            {{ 'general.select' | translate }}
          </option>
          <option *ngFor="let role of roles$ | async" [ngValue]="role.id">
            {{ role.description }}
          </option>
        </select>

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.roleId.dirty && form.controls.roleId.invalid"
        >
          {{ 'general.role' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'general.fromField' | translate }}
        </label>

        <input type="text" class="form-control" formControlName="fromField" />
        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="
            form.controls.fromField.dirty && form.controls.fromField.invalid
          "
        >
          {{ 'general.fromField' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'general.toField' | translate }}
        </label>

        <input type="text" class="form-control" formControlName="toField" />

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.toField.dirty && form.controls.toField.invalid"
        >
          {{ 'general.toField' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'general.value' | translate }}
        </label>

        <input type="text" class="form-control" formControlName="value" />

        <p
          class="invalid-feedback"
          role="alert"
          aria-atomic="true"
          *ngIf="form.controls.value.dirty && form.controls.value.invalid"
        >
          {{ 'general.value' | translate }}
          {{ 'general.isInvalid' | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="form-footer">
    <div
      class="spinner-border"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
      *ngIf="isLoading$ | async"
    >
    </div>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="!form.dirty || (isLoading$ | async)"
      [canSee]="[accessRights.OperationInternalEvents_write]"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
